import { render, staticRenderFns } from "./AssignAgentAdmin.vue?vue&type=template&id=e54ac52e&scoped=true&"
import script from "./AssignAgentAdmin.vue?vue&type=script&lang=js&"
export * from "./AssignAgentAdmin.vue?vue&type=script&lang=js&"
import style0 from "./AssignAgentAdmin.vue?vue&type=style&index=0&id=e54ac52e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54ac52e",
  null
  
)

export default component.exports